import ListView from "../../component/ListView";
import {Column} from "primereact/column";
import rest from "../../utils/EnvConfig";
import moment, {Moment} from "moment";
import Banner from "../../model/Banner";
import {useKeycloak} from "../../keycloak/useKeycloak";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";


function BannerList() {
    const {hasRole, user} = useKeycloak();

    const obterRecursoCorreto = (): string | undefined => {
        if (hasRole(TipoUsuarioKeycloak.ADMIN)) {
            return `${rest.banner}/${rest.obterTodos}`;
        }

        if (hasRole(TipoUsuarioKeycloak.CLIENTE)) {
            return `${rest.banner}/${rest.bannerPorUsuario}${user.id}`;
        }

        return "";
    }

    const dataInicialTemplate = (banner: Banner): string => {
        if (banner.dataInicial) {
            const novaData: Moment = moment(banner.dataInicial, "YYYY-MM-DD");
            return novaData.format("DD/MM/YYYY");
        }
        return "";
    };

    const dataFinalTemplate = (banner: Banner): string => {
        if (banner.dataFinal) {
            const novaData: Moment = moment(banner.dataFinal, "YYYY-MM-DD");
            return novaData.format("DD/MM/YYYY");
        }
        return "";
    };

    const valorTemplate = (banner: Banner): string => {
        if (banner.valor) {
            return banner.valor?.toLocaleString("pt-BR", {
                style: 'currency',
                currency: 'BRL'
            });
        }
        return "";
    };

    return (
        <>
            <ListView title={"Banner"}
                      restCustom={obterRecursoCorreto()}
                      visibleExcluir={(entidade: Banner) => hasRole(TipoUsuarioKeycloak.ADMIN)}
                      id={`${rest.banner}`}>
                <Column field="tipo" header="Tipo" sortable />
                <Column field="restaurante.nomeEstabelecimento" header="Restaurante" sortable />
                <Column field="dataInicial" header="Início da campanha" body={dataInicialTemplate}  sortable />
                <Column field="dataFinal" header="Fim da campanha" body={dataFinalTemplate} sortable />
                <Column field="valor" header="Valor" body={valorTemplate} sortable />
                <Column field="status" header="Situação" sortable />
                <Column field="formaPagamento" header="Forma de pagamento" sortable />
            </ListView>
        </>
    );
}

export default BannerList;